import { TextVisitor } from "@/models/nodes/visitors/TextVisitor";

import type { NodeModel } from "@/models/nodes/types";

type Options = ConstructorParameters<typeof TextVisitor>[0] & {
  xAxisVariable: string;
  yAxisVariable: string;
};

export class GeogebraVisitor extends TextVisitor {
  xAxisVariable: string;

  yAxisVariable: string;

  constructor({ xAxisVariable, yAxisVariable, ...options }: Options) {
    super(options);
    this.xAxisVariable = xAxisVariable;
    this.yAxisVariable = yAxisVariable;
  }

  visitVariableNode(node: NodeModel<"variable">): string {
    if (node.value === this.xAxisVariable) {
      return "x";
    }
    if (node.value === this.yAxisVariable) {
      return "y";
    }
    return super.visitVariableNode(node);
  }

  visitConstantNode(node: NodeModel<"constant">): string {
    if (node.symbolNode?.props.key === "constant-eulers-number") {
      return "e";
    }
    return super.visitConstantNode(node);
  }

  visitOperatorNode(node: NodeModel<"operator">): string {
    if (node.operatorType === "root") {
      const degree = node.nodes[0];
      const radicand = node.nodes[1];
      if (degree && radicand) {
        return `nroot(${radicand.accept(this)}, ${degree.accept(this) || 2})`;
      }
    }

    return super.visitOperatorNode(node);
  }
}
